import React from 'react'
import cn from 'classnames'
import { Modal as ModalComponent } from '@grammarly/badger-ui'

import styles from './modal.module.scss'

export interface ModalAriaProps {
  labelledby: string
  describedby: string
}

interface ModalProps {
  isOpen: boolean
  children: React.ReactNode
  className?: string
  // If there is no visual label in the modal, use the "label" prop to provide a label for the modal content. If a visual label exists, use ModalAriaProps.labelledby attribute instead.
  label?: string
  aria?: Partial<ModalAriaProps>
  rootElementSelector?: string
  onRequestClose?: () => void
}

export const DEFAULT_ROOT_ELEMENT_SELECTOR = '#__next'

export const Modal: React.FC<ModalProps> = (props) => {
  const {
    isOpen,
    aria,
    label,
    rootElementSelector = DEFAULT_ROOT_ELEMENT_SELECTOR,
    children,
    className,
    onRequestClose,
  } = props

  return (
    <ModalComponent
      shouldReturnFocusAfterClose
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      isOpen={isOpen}
      contentLabel={label}
      className={cn(className, styles.modalContainer)}
      overlayClassName={styles.outerOverlay}
      onRequestClose={onRequestClose}
      aria={aria}
      appElementForModal={rootElementSelector}
      onAfterOpen={() => {
        document.body.style.overflow = 'hidden'
      }}
      onAfterClose={() => {
        document.body.style.overflow = 'auto'
      }}
    >
      {children}
    </ModalComponent>
  )
}
